'use client';

import { useTranslations } from 'next-intl';
import useSWR from 'swr';

export function ViewCounter() {
  const t = useTranslations();
  const { data } = useSWR<{ [key: string]: number }>(['/authorities/main/get-counter']);
  return (
    <div className="flex flex-wrap justify-center items-center gap-4 font-medium">
      <p>
        {t('onlayn')} {data?.online_visitors || 0}
      </p>
      <p>
        {t('amallar')} {data?.daily_actions || 0}
      </p>{' '}
      <p>
        {t('tashriflar')} {data?.daily_visits || 0}
      </p>
      <p>
        {t('veb-saytdagi-o-rtacha-vaqt')} {data?.avg_time || 0}
      </p>
    </div>
  );
}
